import { useState } from "react";
import { IPFilter } from "../../../../core/api/organizations/types";
import { updateIpAddress } from "../../../../core/api/organizations/organizations";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { notifyApiErrors } from "../../../../core/helpers/helpers";
import { AddEditIPForm } from "../../../../components/AddEditIPForm";
import useUser from "../../../../core/user/useUser";
import useTranslations from "../../../../core/i18n/useTranslations";

export const CreateEditIPModal = ({
  defaultValues,
  parentId,
  onClose,
  isOpen,
}: {
  defaultValues?: IPFilter;
  parentId: string;
  onClose: (reload?: boolean) => void;
  isOpen: boolean;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values: IPFilter) => {
    try {
      setIsLoading(true);
      await updateIpAddress(
        values.belongsToId,
        values,
        authenticatedRequest,
        defaultValues?.id,
      );
      onClose(true);
      notify({
        message: t(
          `AlarmReceptions:ip_${defaultValues ? "edit" : "create"}_success`,
        ),
      });
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AddEditIPForm
      defaultValues={defaultValues}
      withOrgFilter
      parentId={parentId}
      isOpen={isOpen}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
